let userInitiatedLogout = false;

export const wasUserInitiatedLogout = () => userInitiatedLogout;

export const localLogout = async (keycloak: import("keycloak-js").KeycloakInstance) => {
    userInitiatedLogout = true;
    const userId = keycloak.tokenParsed?.sub;

    // End Busch IoT session before Keycloak redirect
    const buschIotUrl = process.env.REACT_APP_BUSCH_IOT_URL;
    if (buschIotUrl) {
        try {
            await Promise.race([
                fetch(`${buschIotUrl}/account/logout`, {
                    mode: 'no-cors',
                    credentials: 'include',
                }),
                new Promise((_, reject) =>
                    setTimeout(() => reject(new Error('IoT logout timeout')), 5000)
                ),
            ]);
        } catch {
            // Ignore errors — IoT logout is best-effort
        }
    }

    keycloak.logout().then(() => {
        const keysToPreserve: string[] = ['dashboardState'];
        if (userId) {
            keysToPreserve.push(`openAssetTabs_${userId}`, `openSystemTabs_${userId}`);
        }

        const preserved = keysToPreserve.map(key => ({
            key,
            value: localStorage.getItem(key),
        }));
        localStorage.clear();
        preserved.forEach(({ key, value }) => {
            if (value !== null) {
                localStorage.setItem(key, value);
            }
        });
    });
}
